import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import SmartLink from "../fragments/SmartLink";
import Image from "../fragments/Image";
import { useReveal } from '../hooks/UseReveal';

import SpecialText from "../fragments/SpecialText";
import Thumbnail from "../fragments/Thumbnail";

export default function RelatedPosts({ block }) {

	const swiperRef = useRef(null);
	const revealRef = useReveal({ once: true });

	if (!block || !block.projects || block.projects.length === 0) return null;

	return (
		<div id={block.section_id} className="c-page__block c-page__block--project-grid">
			<div className="l-grid">
				{block.heading && (
					<div className="l-grid__col c-transition-in" ref={revealRef}>
						<h2 className="c-related-posts__heading c-heading">
							<SpecialText text={block.heading} />
						</h2>
					</div>
				)}
			</div>
			<div className="l-grid">
				<div className="l-grid__col">
					<div className="c-project-grid">
						{block.projects.map((post, index) => {
							return (
								<div className="c-project-grid__cell" key={index}>
									<Thumbnail post={post} limitHeight={true} />
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
} 